import type {
  EshopCategoryApiField,
  EshopsData,
  StaticTextsConfig,
} from '@twisto/api-cms'

import type { EshopSelection } from '../../molecules/eshops-navigation/types'

const ESHOP_LIST_TITLES = [
  ['pay_in_three_eshops', 'payInThreeEshopsTitle'],
  ['merchant_benefits', 'recommendedEshopsTitle'],
  ['popular_eshops', 'popularEshopsTitle'],
  ['newest_eshops', 'newestEshopsTitle'],
] as const satisfies ReadonlyArray<
  readonly [Exclude<EshopCategoryApiField, 'all'>, keyof StaticTextsConfig]
>

export const getEshopLists = (
  data?: EshopsData,
  staticTexts?: StaticTextsConfig
) =>
  ESHOP_LIST_TITLES.map(([field, titleKey]) => ({
    field,
    title: staticTexts?.[titleKey],
    eshops: data?.[field],
  }))

export const getSelectedEshops = (
  selection: EshopSelection,
  data?: EshopsData
) => {
  if (selection.type === 'pay-in-3') {
    return data?.pay_in_three_eshops || []
  }

  if (selection.type === 'category') {
    return (data?.eshops || []).filter(
      (eshop) =>
        Array.isArray(eshop.categories) &&
        eshop.categories.includes(selection.category.slug)
    )
  }

  return []
}
